import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  printReviewSuccess,
  printReviewFailure,
  //
  printScoreSuccess,
  printScoreFailure,
  //
  printBadgeSuccess,
  printBadgeFailure,
} from "./actions";
import { PRINT_REVIEW, PRINT_SCORE, PRINT_BADGE } from "./constants";

export function* printScoreSaga({ payload, scoreSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token, null, false, true).post,
      `/api/review-score-certificate`,
      payload
    );
    if (data) {
      typeof scoreSuccess === "function" && scoreSuccess(data);
      yield put(printScoreSuccess());
    }
  } catch (e) {
    yield put(printScoreFailure());
    yield put(errorAlert(`Error while printing!`));
  }
}

export function* printReviewSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token, null, false, true).get,
      `/api/single-review-print/${payload?.id}`
    );
    if (data) {
      yield put(printReviewSuccess());
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${payload?.title} Review.pdf`);
      document.body.appendChild(link);
      link.click();
    }
  } catch (e) {
    yield put(printReviewFailure());
    yield put(errorAlert(`Error while printing!`));
  }
}

export function* printBadegeSaga({ payload, badgeSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token, null, false, true).get,
      `/api/review-stamp-sticker`
    );
    if (data) {
      typeof badgeSuccess === "function" && badgeSuccess(data);
      yield put(printBadgeSuccess());
    }
  } catch (e) {
    yield put(printBadgeFailure());
    yield put(errorAlert(`Error while printing!`));
  }
}

export function* printScoreFlow() {
  yield takeEvery(PRINT_SCORE, printScoreSaga);
}
export function* printReviewFlow() {
  yield takeEvery(PRINT_REVIEW, printReviewSaga);
}
export function* printBadegeFlow() {
  yield takeEvery(PRINT_BADGE, printBadegeSaga);
}

export default function* PrintSaga() {
  yield all([printScoreFlow(), printReviewFlow(), printBadegeFlow()]);
}
